import { useState, useEffect } from 'react';
import { api } from '../services/api';

function FormLinkGenerator({ ticketId, integrationKey, onLinkGenerated }) {
  const [formDefs, setFormDefs] = useState([]);
  const [loadingDefs, setLoadingDefs] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [generating, setGenerating] = useState(false);
  const [formData, setFormData] = useState({
    formDefId: '',
    sendEmail: true,
  });

  useEffect(() => {
    loadFormDefinitions();
  }, []);

  const loadFormDefinitions = async () => {
    try {
      const defs = await api.listFormDefinitions(integrationKey);
      setFormDefs(defs);
      if (defs.length > 0) {
        setFormData(prev => ({ ...prev, formDefId: defs[0].formDefId }));
      }
    } catch (err) {
      console.error('Error loading form definitions:', err);
    } finally {
      setLoadingDefs(false);
    }
  };

  const handleGenerate = async () => {
    if (!formData.formDefId) return;

    try {
      setGenerating(true);
      const result = await api.generateFormLink({
        formDefId: formData.formDefId,
        ticketId,
        sendEmail: formData.sendEmail,
      }, integrationKey);

      setShowForm(false);

      if (onLinkGenerated) {
        onLinkGenerated(result);
      }
    } catch (err) {
      alert('Failed to generate form link');
    } finally {
      setGenerating(false);
    }
  };

  if (loadingDefs) {
    return (
      <div className="text-center py-2">
        <p className="text-xs text-gray-500">Loading forms...</p>
      </div>
    );
  }

  if (formDefs.length === 0) {
    return (
      <div className="text-center py-4 text-xs text-gray-500 bg-gray-50 border border-gray-200 rounded">
        No form templates configured yet
      </div>
    );
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-sm font-medium text-gray-900">Client Forms</h3>
        <button
          onClick={() => setShowForm(!showForm)}
          className="text-xs bg-primary-600 text-white px-3 py-1 rounded hover:bg-primary-700"
        >
          {showForm ? 'Cancel' : '+ Send Form'}
        </button>
      </div>

      {showForm && (
        <div className="bg-gray-50 border border-gray-200 rounded p-3 mb-3">
          <div className="space-y-2">
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">
                Form Template
              </label>
              <select
                value={formData.formDefId}
                onChange={(e) => setFormData({ ...formData, formDefId: e.target.value })}
                className="w-full text-xs px-2 py-1 border border-gray-300 rounded focus:ring-1 focus:ring-primary-500"
              >
                {formDefs.map((def) => (
                  <option key={def.formDefId} value={def.formDefId}>
                    {def.title} ({def.fieldCount} fields)
                  </option>
                ))}
              </select>
            </div>

            <p className="text-xs text-gray-500">
              Client name and email will be pulled from the ticket automatically.
            </p>

            <div className="flex items-center">
              <input
                type="checkbox"
                id="sendFormEmail"
                checked={formData.sendEmail}
                onChange={(e) => setFormData({ ...formData, sendEmail: e.target.checked })}
                className="h-3 w-3 text-primary-600 border-gray-300 rounded"
              />
              <label htmlFor="sendFormEmail" className="ml-2 text-xs text-gray-700">
                Email form link to client via Halo ticket
              </label>
            </div>

            <button
              onClick={handleGenerate}
              disabled={generating || !formData.formDefId}
              className="w-full bg-primary-600 text-white text-xs px-3 py-2 rounded hover:bg-primary-700 disabled:opacity-50"
            >
              {generating ? 'Generating...' : 'Send Form to Client'}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default FormLinkGenerator;
